import { gql } from '@grandvisionhq/graphql';

const store = gql`
  fragment Reschedule_StoreByCode on Store {
    town
    additionalStreetInfo
    streetNumber
    streetName
    name
    postalCode
    code
    slug
    province
    country
    lat
    lon
    phone
    email
  }
`;
const GET_STORE_BY_CODE = gql`
  query RescheduleAppointment_GetStoreByCode($code: Int!) {
    store(code: $code) {
      ...Reschedule_StoreByCode
    }
  }
  ${store}
`;

export { GET_STORE_BY_CODE };
//# sourceMappingURL=get-store-by-code.js.map
